module.exports = __webpack_public_path__ + "img/Logo-Calce-superior.073d3041.png";